var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.popupId,
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myLargeModalLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h2", [
              _vm._v(
                _vm._s(_vm.action == "ACTIVE" ? "Activate" : "Deactivate") +
                  " User"
              )
            ]),
            _c("button", {
              ref: "closeDactivatePopupButton",
              staticClass: "close",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                "aria-label": "Close"
              }
            })
          ]),
          _c("div", { staticClass: "modal-body" }, [
            _c("p", [_vm._v("Are you sure?")]),
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _c("div", { staticClass: "col-xs-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-lg-green",
                    on: { click: _vm.updateUserStatus }
                  },
                  [_vm._v("YES")]
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-6" }, [
      _c(
        "button",
        { staticClass: "btn-lg-grey", attrs: { "data-dismiss": "modal" } },
        [_vm._v("NO")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }